// extracted by mini-css-extract-plugin
export default {"setting--inverted":"qL6A2Hw","dark-theme":"mVupUIU","banner":"y0axRvV","content":"fOH6LbA","image":"l7o_Wqo","textContainer":"jaiVUBj","headline":"ZHDpLP1","text":"dgNFsv3"};